import {useEffect, useRef} from 'react';
import {usePageVisibility} from '@shared/core/hooks/';

function useInterval(callback: () => void, delay: number | null | undefined): void {
  const savedCallback = useRef<() => void>(callback);
  const isPageVisible = usePageVisibility();

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    if (delay == null || delay <= 0 || !isPageVisible) return;

    const tick = () => {
      if (savedCallback.current) {
        savedCallback.current();
      }
    };

    const id = setInterval(tick, delay);
    return () => {
      clearInterval(id);
    };
  }, [delay, isPageVisible]);
}

export default useInterval;
